import script from "./UsersSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersSummary.vue?vue&type=script&setup=true&lang=js"

import "./UsersSummary.vue?vue&type=style&index=0&id=28c5b43e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c5b43e"]])

export default __exports__